import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import MarkAsUnreadIcon from "@mui/icons-material/MarkAsUnread";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemNotificationProps<
  TRow extends object = Record<string, unknown>,
> {
  row?: TRow & { Read?: boolean };
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

export const MenuItemNotification = <
  TRow extends object = Record<string, unknown>,
>(
  props: MenuItemNotificationProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  //#endregion useMemo

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleViewAction = () => {
    props.menuClick(`${menuFor}-view`, props.row);
    handleClose();
  };

  const handleReadAction = () => {
    props.menuClick(`${menuFor}-read`, props.row);
    handleClose();
  };

  const handleUnreadAction = () => {
    props.menuClick(`${menuFor}-unread`, props.row);
    handleClose();
  };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      <MenuItem onClick={handleViewAction}>
        <ListItemIcon>
          <VisibilityIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("View")} />
      </MenuItem>
      {!props?.row?.Read ? (
        <MenuItem onClick={handleReadAction}>
          <ListItemIcon>
            <MarkEmailReadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Mark As Read")} />
        </MenuItem>
      ) : (
        <MenuItem onClick={handleUnreadAction}>
          <ListItemIcon>
            <MarkAsUnreadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Mark As Unread")} />
        </MenuItem>
      )}

      <MenuItem onClick={handleDeleteAction}>
        <ListItemIcon>
          <DeleteIcon color="error" fontSize="small" />
        </ListItemIcon>
        <ListItemText
          slotProps={{ primary: { color: "error" } }}
          primary={gettext("Delete")}
        />
      </MenuItem>
    </>
  );
};
